import React, {useState} from 'react';
import {Box, VStack, Input, useTheme} from '@chakra-ui/react';
import {TextG14, TextG24} from '../../components/typography';
import {isValidPhoneNumber} from 'libphonenumber-js';

interface Intro3PhoneProps {
  onValidationChange: (isValid: boolean) => void;
  onDataChange: (phoneNumber: string) => void;
  initialPhone?: string;
}

const IntroPhone = ({onValidationChange, onDataChange, initialPhone}: Intro3PhoneProps) => {
  const theme = useTheme();
  const [phone, setPhone] = useState(initialPhone || '');
  const [touched, setTouched] = useState(false);

  const formatPhoneNumber = (value: string) => {
    // Remove all non-digits
    const digitsOnly = value.replace(/\D/g, '');
    
    // Format as (XXX) XXX-XXXX
    if (digitsOnly.length <= 3) {
      return digitsOnly;
    } else if (digitsOnly.length <= 6) {
      return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`;
    } else {
      return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
    }
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
    
    // Get raw digits for validation
    const digitsOnly = formattedPhone.replace(/\D/g, '');
    const phoneWithCountryCode = `+1${digitsOnly}`;
    
    const isValid = digitsOnly.length === 10 && isValidPhoneNumber(phoneWithCountryCode);
    onValidationChange(isValid);
    onDataChange(phoneWithCountryCode);
  };

  const error = touched && phone.length > 0 && phone.replace(/\D/g, '').length !== 10
    ? 'Phone number must be 10 digits'
    : '';

  return (
    <VStack
      flex={1}
      spacing={6}
      px={4}
      pt={4}
      pb={4}
      align="stretch"
      justify="flex-start"
      overflow="auto">
      {/* Title */}
      <Box>
        <TextG24 fontSize="26px" fontWeight="700" color="#262626">
          What's your number?
        </TextG24>
      </Box>

      {/* Description */}
      {/* <TextG14 color="#262626" fontWeight="500" lineHeight="22px" mt={-2}>
        We'll send you a verification code to confirm it's you.
      </TextG14> */}

      {/* Phone Input */}
      <Box>
        <Input
          placeholder="(619) 123-4567"
          value={phone}
          onChange={handlePhoneChange}
          onBlur={() => setTouched(true)}
          size="lg"
          borderRadius="12px"
          border="1px solid"
          borderColor={error ? theme.colors.red[500] : theme.colors.gray[300]}
          _focus={{
            borderColor: error ? theme.colors.red[500] : '#C9136B',
            boxShadow: 'none',
          }}
          fontSize="16px"
          py={6}
          type="tel"
          maxLength={14}
        />
        {error && (
          <TextG14 color={theme.colors.red[500]} mt={1} ml={2}>
            {error}
          </TextG14>
        )}
      </Box>
    </VStack>
  );
};

export default IntroPhone;
